import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.trim();
const key = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined)?.trim();

/** Null until Kyle links a Supabase project: the app still renders, with a banner. */
export const supabase: SupabaseClient | null = url && key && /^https?:\/\//.test(url) ? createClient(url, key) : null;

export const backendConfigured = supabase !== null;

/** Throws on a PostgREST error, returns the data otherwise. */
export function unwrap<T>(res: { data: T | null; error: { message: string } | null }): T {
  if (res.error) throw new Error(res.error.message);
  return res.data as T;
}

/** Page through a query 1000 rows at a time (config.toml caps max_rows at 5000). */
export async function fetchAll<T>(make: (from: number, to: number) => PromiseLike<{ data: T[] | null; error: { message: string } | null }>): Promise<T[]> {
  const page = 1000;
  const out: T[] = [];
  for (let from = 0; ; from += page) {
    const res = await make(from, from + page - 1);
    if (res.error) throw new Error(res.error.message);
    const rows = res.data ?? [];
    out.push(...rows);
    if (rows.length < page) break;
  }
  return out;
}
